import WJSON from '../libs/wjson';

const UPDATE_BADGE_INFO = "UPDATE_BADGE_INFO";
const CLEAN_BADGE_INFO  = "CLEAN_BADGE_INFO";

// dispatch function
export const updateBadgeInfo = (newState) => ({ type : UPDATE_BADGE_INFO, newState })
export const cleanBadgeInfo  = (newState) => ({ type : CLEAN_BADGE_INFO, newState })

const defaultBadgeInfo = {
  shop_in_application : 0,
}

// reducer
export default (state = {}, action) => {
  
  let badges = WJSON.decode(localStorage.getItem('wbadge')) || defaultBadgeInfo
  
  badges = {...defaultBadgeInfo, ...badges, ...state}

  if (action.type === UPDATE_BADGE_INFO)
  {
    badges = { ...badges, ...action.newState }

    localStorage.setItem('wbadge', WJSON.encode(badges))

    return badges
  }

  if (action.type === CLEAN_BADGE_INFO )
  {
    localStorage.setItem('wbadge', WJSON.encode(defaultBadgeInfo))

    return defaultBadgeInfo
  }

  return badges
}


// WEBPACK FOOTER //
// ./src/reducers/badge.js